(() => {
  const ROOT = '[data-elx-scene-showcase]';

  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll(ROOT)];
    if (scope.matches?.(ROOT)) roots.unshift(scope);

    roots.forEach((root) => {
      if (root.dataset.elxSceneReady === 'true') return;
      root.dataset.elxSceneReady = 'true';

      const tabs = [...root.querySelectorAll('[data-elx-scene-tab]')];
      const panels = [...root.querySelectorAll('[data-elx-scene-panel]')];
      const panelFor = (key) => panels.find((panel) => panel.dataset.elxScenePanel === key);

      const setActiveHotspot = (panel, key) => {
        if (!panel) return;

        panel.querySelectorAll('[data-elx-scene-hotspot]').forEach((hotspot) => {
          const active = hotspot.dataset.elxSceneHotspot === key;
          hotspot.classList.toggle('is-active', active);
          hotspot.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', String(active));
        });

        panel.querySelectorAll('[data-elx-scene-mobile-card]').forEach((card) => {
          card.classList.toggle('is-active', card.dataset.elxSceneMobileCard === key);
        });
      };

      const setActivePanel = (key) => {
        const panel = panelFor(key) || panels[0];
        if (!panel) return;

        panels.forEach((item) => {
          const active = item === panel;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
        });

        tabs.forEach((tab) => {
          const active = tab.getAttribute('aria-controls') === panel.id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        setActiveHotspot(panel, panel.querySelector('[data-elx-scene-hotspot]')?.dataset.elxSceneHotspot || '');
      };

      panels.forEach((panel) => {
        const initial = panel.classList.contains('is-active');
        panel.setAttribute('aria-hidden', String(!initial));
        if (initial) {
          setActiveHotspot(panel, panel.querySelector('[data-elx-scene-hotspot].is-active, [data-elx-scene-hotspot]')?.dataset.elxSceneHotspot || '');
        }
      });

      tabs.forEach((tab) => tab.addEventListener('click', () => setActivePanel(tab.dataset.elxSceneTab)));

      root.querySelectorAll('[data-elx-scene-hotspot]').forEach((hotspot) => {
        hotspot.querySelector('button')?.addEventListener('click', () => {
          const panel = hotspot.closest('[data-elx-scene-panel]');
          const key = hotspot.dataset.elxSceneHotspot;
          setActiveHotspot(panel, hotspot.classList.contains('is-active') ? '' : key);
        });
      });

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        setActiveHotspot(root.querySelector('[data-elx-scene-panel].is-active'), '');
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
